import "core-js/modules/es.object.assign.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { SET_IM_SESSION, CLOSE_CHAT_BOX } from "./Types";
import { OPEN_CONTACT } from "../contacts/Types";
import { assert } from "@/common/assert";
var initialState = {
  myself: undefined,
  chatClient: undefined,
  isChatBoxOpen: false
};
export function ImSessionReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case SET_IM_SESSION:
      assert(action.myself, "action.myself");
      assert(action.myself.clientId, "action.myself.clientId");
      return __assign(__assign({}, state), {
        chatClient: action.chatClient,
        myself: action.myself
      });

    case CLOSE_CHAT_BOX:
      return __assign(__assign({}, state), {
        isChatBoxOpen: false
      });

    case OPEN_CONTACT:
      return __assign(__assign({}, state), {
        isChatBoxOpen: true
      });

    default:
      return state;
  }
}